<template>
  <div
    style="
      padding: 8px 6px 2px;
      background-color: rgb(241, 240, 240);
      border-radius: 10px;
      height: 100%;
    "
  >
    <div v-if="isEdit">
      <div class="form-control">
        <AutoresizeTextarea
          v-model="value.message1"
          :maxlength="640 - (value.message2.length + totalLength)"
          class="form-control"
          @input="onChangeMessage($event, 'message1')"
        ></AutoresizeTextarea>
      </div>
      <div>
        <div class="form-control" style="position: relative">
          <AutoresizeTextarea
            disabled
            :class="{ 'form-control': true, readonly: true }"
            value="{detail}"
          ></AutoresizeTextarea>
          <div style="position: absolute; right: 5px; top: -8px">
            <v-switch v-model="value.detailstatus" color="primary" small></v-switch>
          </div>
        </div>
      </div>
      <div>
        <div class="form-control" style="position: relative">
          <AutoresizeTextarea
            disabled
            :class="{ 'form-control': true, readonly: true }"
            value="{shipping}"
          ></AutoresizeTextarea>
          <div style="position: absolute; right: 5px; top: -8px">
            <v-switch v-model="value.shippingstatus" color="primary" small></v-switch>
          </div>
        </div>
      </div>
      <div class="form-control">
        <AutoresizeTextarea
          v-model="value.message2"
          :maxlength="640 - (value.message1.length + totalLength)"
          class="form-control"
        ></AutoresizeTextarea>
      </div>

      <div
        :class="{
          'text-xs-right': true,
          caption: true,
          'red--text': value.message1.length + value.message2.length > 640
        }"
      >
        {{ value.message1.length + value.message2.length }}/{{ 640 - totalLength }}
      </div>
    </div>
    <div v-else style="font-size: 12px">
      <div style="float: right">
        <v-btn small icon outline color="primary" @click="editPattern">
          <v-icon small>edit</v-icon>
        </v-btn>
      </div>
      <div class="pa-3">
        <nl2br
          :class-name="'wrapword'"
          style="word-break: break-word"
          tag="p"
          :text="value.message1"
        />
        <div v-if="value.detailstatus" class="my-2">
          Shirt (L): 100 Baht
          <br />----------------------------- <br />💰Total (not including shipping) 100 Baht
          <br />-----------------------------
        </div>

        <div v-if="value.shippingstatus" class="my-2">
          Shipping option
          <br />📦Thailand Post Free
          <br />
        </div>
        <nl2br tag="p" :text="value.message2" />
      </div>
    </div>
    <div v-if="isEdit" class="text-xs-center">
      <v-btn outline color="grey" @click="cancelEditPattern">{{ $t('cancel') }}</v-btn>
      <v-btn :loading="updateloading" depressed color="primary" @click="onSave">{{
        $t('save')
      }}</v-btn>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea.vue'
import specialtext from '@/components/elements/specialtext'
import nl2br from 'vue-nl2br'

export default {
  components: {
    AutoresizeTextarea,
    specialtext,
    nl2br
  },
  props: {
    value: {
      default: {
        message1: '',
        message2: '',
        detailstatus: false,
        shippingstatus: false
      }
    },
    type: {
      default: ''
    },
    patterntype: {
      default: 'setting'
    }
  },
  data() {
    return {
      isEdit: false,
      temppattern: '',
      updateloading: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    totalLength() {
      var a = 0
      var b = 0
      if (this.value.detailstatus) a = 100
      if (this.value.shippingstatus) b = 100
      return a + b
    }
  },
  methods: {
    onChangeMessage(e, message) {
      this.value[message] = e.slice(0, 640 - this.totalLength)
    },
    onSave() {
      if (this.value.message1.length + this.value.message2.length <= 640 - this.totalLength) {
        if (this.patterntype == 'setting') {
          this.putcartsummarypattern()
        } else if (this.patterntype == 'products') {
          this.isEdit = false
          this.$emit('onSave')
        }
      }
    },
    putcartsummarypattern(pattern, shippingstatus, type) {
      this.updateloading = true
      var data = {
        pageid: this.selectedBot.pageid,
        pattern: JSON.stringify(this.value),
        type: this.type,
        shippingpattern_status: true
      }
      api.putcartsummarypattern(data, (err, response) => {
        this.updateloading = false
        this.isEdit = false
      })
    },
    editPattern() {
      this.temppattern = JSON.stringify(this.value)
      this.isEdit = true
    },
    cancelEditPattern() {
      this.$emit('input', JSON.parse(this.temppattern))
      //   this.value =
      this.isEdit = false
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapword {
  word-break: break-word;
}
.readonly {
  background-color: #f3f3f3;
}
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}
p {
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/view/live/MessageItem.vue